@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackTestimonialResults {
  .title {
    font-size: 34px;
    margin-bottom: 30px;
    text-align: center;
    color: var(--black);

    @include texts.font("semi-bold");

    .icon {
      width: 36px;
      height: 36px;
      position: relative;
      top: 9px;
      filter: var(--icon-web-green);
      display: inline-block;

      @include icons.ico("black-pos-track");
    }
  }

  .cases {
    display: flex;
    flex-direction: column;
    gap: 50px;

    .case {
      border-radius: 22px;
      padding: 25px;
      border: 1px solid rgba(255, 255, 255, 0.18);
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.06) 100%);
      display: flex;
      flex-direction: column;
      gap: 5px;
      position: relative;
      width: 100%;
      color: var(--black);

      .name {
        font-size: 24px;
        position: relative;
        z-index: 1;

        @include texts.font("semi-bold");
      }

      .description {
        font-size: 15px;
        max-width: 650px;
        margin-bottom: 15px;
      }

      .image {
        border-radius: 14px;
        width: 100%;
        border: 1px solid var(--grey-sur);
      }
    }
  }

  @media screen and (max-width: 480px) {
    .case {
      padding: 0 !important;
    }
  }

}